import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  correction: {
    marginLeft: theme.spacing(9.5),
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(3.5),
    },
  },
}));

export default useStyles;
